var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExperienceSwitch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03007 1.65905C8.88607 0.111047 11.1111 0.111047 11.9671 1.65905L19.7131 15.66C20.5431 17.16 19.4581 19 17.7441 19H2.25407C0.539071 19 -0.545929 17.16 0.284071 15.66L8.03007 1.65905Z",
    fill: "url(#paint0_linear_7271_614)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.997 14.9998C11.0012 14.866 10.9786 14.7327 10.9303 14.6079C10.882 14.483 10.8091 14.3692 10.716 14.273C10.6229 14.1769 10.5114 14.1005 10.3881 14.0483C10.2648 13.9961 10.1324 13.9692 9.99851 13.9692C9.86466 13.9692 9.73218 13.9961 9.60892 14.0483C9.48567 14.1005 9.37416 14.1769 9.28103 14.273C9.18789 14.3692 9.11502 14.483 9.06675 14.6079C9.01847 14.7327 8.99578 14.866 9.00001 14.9998C9.00822 15.2591 9.11702 15.5051 9.30338 15.6857C9.48973 15.8662 9.73903 15.9672 9.99851 15.9672C10.258 15.9672 10.5073 15.8662 10.6936 15.6857C10.88 15.5051 10.9888 15.2591 10.997 14.9998ZM10.738 7.14777C10.7121 6.95944 10.6156 6.78797 10.4681 6.66805C10.3206 6.54812 10.1331 6.4887 9.94339 6.50178C9.75373 6.51486 9.57612 6.59949 9.44647 6.73853C9.31682 6.87757 9.24482 7.06066 9.24501 7.25077L9.24901 11.7518L9.25601 11.8538C9.28192 12.0421 9.37839 12.2136 9.52591 12.3335C9.67342 12.4534 9.86097 12.5129 10.0506 12.4998C10.2403 12.4867 10.4179 12.4021 10.5476 12.263C10.6772 12.124 10.7492 11.9409 10.749 11.7508L10.745 7.24877L10.738 7.14777Z",
    fill: "url(#paint1_linear_7271_614)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7271_614",
    x1: 3.12507,
    y1: -2.39295,
    x2: 14.7191,
    y2: 21.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8401"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7271_614",
    x1: 7.33601,
    y1: 6.49977,
    x2: 11.752,
    y2: 16.4048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceSwitch);
export default __webpack_public_path__ + "static/media/experience-Switch.bef821c52d6f365df120c7cf16770888.svg";
export { ForwardRef as ReactComponent };